// extracted by mini-css-extract-plugin
export default {"helloContainer":"Animation_helloContainer__ifO8k","helloContainer__text":"Animation_helloContainer__text__IzGWO","fadeInOut":"Animation_fadeInOut__h5U9k"};